import { Link } from "react-router-dom";
import { rooms } from "./roomData";
import "./RoomService.css";
import "./RoomServiceRed.css";

const RoomList = () => (
  <main className="room-page">
    <section className="room-list-hero">
      <p className="eyebrow">A stay made simple</p>
      <h1>Find your perfect room</h1>
      <p>Choose from our considered collection of rooms and suites. Availability is updated in real time.</p>
    </section>

    <section className="rooms-section" aria-labelledby="rooms-heading">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Available to book</p>
          <h2 id="rooms-heading">Rooms & suites</h2>
        </div>
        <span className="availability-key"><i /> Available now <b /> Booked</span>
      </div>
      <div className="room-grid">
        {rooms.map((room) => {
          const card = <article className={`room-card ${room.status === "occupied" ? "is-occupied" : ""}`}>
            <div className="room-image-wrap">
              <img src={room.image} alt={room.name} className="room-image" />
              <span className={`room-status ${room.status}`}>{room.status === "available" ? "Available now" : "Booked"}</span>
            </div>
            <div className="room-card-content">
              <p className="room-type">{room.type}</p>
              <h3>{room.name}</h3>
              <p className="room-meta">Up to {room.guests} guests <span>•</span> {room.size}</p>
              <div className="room-card-footer">
                <p><strong>₦{room.price.toLocaleString()}</strong> / night</p>
                {room.status === "available" ? <span className="view-room">Book this room <span aria-hidden="true">→</span></span> : <span className="booked-label">Not available</span>}
              </div>
            </div>
          </article>;
          return room.status === "available" ? <Link to={`/room-service/${room.id}`} className="room-link" key={room.id}>{card}</Link> : <div key={room.id}>{card}</div>;
        })}
      </div>
    </section>
  </main>
);

export default RoomList;
